import type { SimpleCardProps } from '#/components/ui/SimpleCard';

export const DEFAULT_LEARN_MORE_RESOURCE_CARDS = [
  {
    title: 'FINRA BrokerCheck',
    content:
      'Use our free tool to confirm whether investment professionals and firms are licensed.',
    href: 'https://brokercheck.finra.org/',
  },
  {
    title: 'Financial Literacy Quiz',
    content:
      'Test how your financial knowledge stacks up nationally and against others in your state.',
    href: 'https://www.finra.org/financial_knowledge_quiz',
  },
  {
    title: 'Risk Meter',
    content:
      'See whether you share traits that have been shown to make some investors vulnerable to investment fraud.',
    href: 'https://riskmeterquiz.finra.org/',
  },
] as const satisfies SimpleCardProps[];
